import { MdEdit } from "react-icons/md";
import { RecruiterCommentInterface } from "../../../../models/recruiter-comment.model";
import {
  CommentContainer,
  Container,
  Description,
  EditButton,
  Footer,
  LastEdited,
  ShowAllButton,
} from "./index.styled";
import { useTranslation } from "react-i18next";

interface CommentProps {
  comment?: RecruiterCommentInterface;
  lastEdited: string;
  handleEdit: () => void;
  setDetail: () => void;
}
const Comment: React.FC<CommentProps> = ({
  comment,
  lastEdited,
  handleEdit,
  setDetail,
}) => {
  const { t } = useTranslation("private-home-page");

  return (
    <Container>
      {comment && (
        <CommentContainer>
          {comment.editable && (
            <EditButton onClick={handleEdit}>
              <MdEdit />
            </EditButton>
          )}
          <Description
            dangerouslySetInnerHTML={{
              __html:
                comment.comment.length > 400
                  ? `${comment.comment.slice(0, 400)}...`
                  : comment.comment,
            }}
          />
          {comment.comment.length > 400 && (
            <ShowAllButton onClick={setDetail}>
              {t("talent.showAll")}
            </ShowAllButton>
          )}
        </CommentContainer>
      )}
      <Footer onClick={setDetail}>
        {!!comment && lastEdited && <LastEdited>{lastEdited}</LastEdited>}
      </Footer>
    </Container>
  );
};

export default Comment;
